<template>
    <component :is="component" :memberData="memberData" :accountData="accountData"  v-if="component"/>
</template>

<script>
    export default {
        name: "MemberWriteLink",
        mixins: [],
        components: {},
        provide() {
            return {}
        },
        props: {
            writeLayout: {},
            memberData: {default: () => {}},
            accountData: {default: () => {}},
        },
        data() {
            return {
                component: null,
            }
        },
        created() {},
        mounted() {
            this.writeLoader()
        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
            loader() {
                if (!this.writeLayout) {
                    return null
                }
                return () => import(`@/template/member/write/${this.writeLayout}`)
            },
        },
        methods: {
            writeLoader() {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/member/write/MemberWriteDefaultLayout')
                    })
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>